import React from 'react';

type DailyMetrics = {
  sleepStage: boolean;
  noise: boolean;
  posture: boolean;
  temperature: boolean;
};

type DailyMetricSelectorProps = {
  selectedMetrics: DailyMetrics;
  onMetricToggle: (metric: keyof DailyMetrics) => void;
};

export const DailyMetricSelector: React.FC<DailyMetricSelectorProps> = ({ selectedMetrics, onMetricToggle }) => {
  return (
    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-800 mb-3">表示する項目を選択</h3>
      <div className="flex flex-wrap gap-4">
        <label className="flex items-center space-x-2 cursor-pointer">
          <input
            type="checkbox"
            checked={selectedMetrics.sleepStage}
            onChange={() => onMetricToggle('sleepStage')}
            className="w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500"
          />
          <span className="text-gray-700">睡眠ステージ</span>
        </label>
        <label className="flex items-center space-x-2 cursor-pointer">
          <input
            type="checkbox"
            checked={selectedMetrics.noise}
            onChange={() => onMetricToggle('noise')}
            className="w-4 h-4 text-red-600 rounded focus:ring-2 focus:ring-red-500"
          />
          <span className="text-gray-700">ノイズレベル</span>
        </label>
        <label className="flex items-center space-x-2 cursor-pointer">
          <input
            type="checkbox"
            checked={selectedMetrics.posture}
            onChange={() => onMetricToggle('posture')}
            className="w-4 h-4 text-green-600 rounded focus:ring-2 focus:ring-green-500"
          />
          <span className="text-gray-700">姿勢</span>
        </label>
        <label className="flex items-center space-x-2 cursor-pointer">
          <input
            type="checkbox"
            checked={selectedMetrics.temperature}
            onChange={() => onMetricToggle('temperature')}
            className="w-4 h-4 text-yellow-600 rounded focus:ring-2 focus:ring-yellow-500"
          />
          <span className="text-gray-700">ベッド温度</span>
        </label>
      </div>
    </div>
  );
};
